export default "__VITE_ASSET__BI4MHKPR__"